import { Link } from "react-router-dom";
import "./Footer.css";

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__col footer__col--brand">
          <Link to="/" className="footer__brand">
            <img
              src="/silico-logo.png"
              alt=""
              className="footer__mark"
              width="32"
              height="32"
              draggable={false}
            />
            <span>SilicoInformatics</span>
          </Link>
          <p className="footer__tagline">
            AI for life sciences. Delivered with measurable impact.
          </p>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Solutions</h4>
          <Link to="/services">Services & Products</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Account</h4>
          <Link to="/login">Sign in</Link>
          <Link to="/signup">Create account</Link>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Get in touch</h4>
          <a href="mailto:contact@silicoinformatics.com">contact@silicoinformatics.com</a>
          <a href="mailto:sales@silicoinformatics.com">sales@silicoinformatics.com</a>
        </div>
      </div>

      <div className="container footer__bottom">
        <p>© {new Date().getFullYear()} SilicoInformatics. All rights reserved.</p>
      </div>
    </footer>
  );
}
